// extracted by mini-css-extract-plugin
module.exports = {"header":"header-10472c69","logo":"logo-48fad896"};